module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "scheduler_user",
    class: [{
        'isAbsence': _vm.user.dayAbsence.length > 0
      },
      {
        'isPotentialSub': _vm.user.dayAbsence.length < 1
      },
      {
        'item-is-headline': _vm.user.headline
      }
    ],
    style: ({
      'min-height': _vm.userMinHeight
    }),
    on: {
      "mouseenter": function($event) {
        _vm.isShowSelectButton = true
      },
      "mouseleave": function($event) {
        _vm.isShowSelectButton = false
      }
    }
  }, [_vm._l((_vm.correctEventsFiltered), function(event) {
    return _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return event.obj.hasOwnProperty('v_is_event_from_other_school'); }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => event.obj.hasOwnProperty('v_is_event_from_other_school')\n            }"
      }],
      key: _vm.user.id + '_' + event.obj.id,
      ref: _vm.calEvent,
      refInFor: true,
      staticClass: "day-cal__event day-cal__event__lesson",
      class: [{
          'isActiveEvent animated bigPulseTwo infinite': _vm.activeEvent && event.obj.id === _vm.activeEvent.obj.id && _vm.activeUser && _vm.user.id === _vm.activeUser.id
        },
        {
          'day-cal__event__handled': event.obj.v_status === 1
        },
        {
          'day-cal__event__pending': event.obj.v_status === 2
        },
        {
          'day-cal__event day-cal__event__lesson--from-other-school': event.obj.v_is_event_from_other_school
        },
        {
          'day_cal__event__lesson__overlaps_absent': event.overlapsAbsent,
          'day_cal__event__lesson__canceled': event.obj.canceled
        },
        event.subs.length > 0 ? 'hint--left hint--success' : 'hint--right'
      ],
      style: ([{
          'top': event.row * 26 + _vm.hasAbsence + 'px'
        },
        {
          'left': event.left + 'px'
        },
        {
          'right': event.right + 'px'
        },
        {
          'height': '25px'
        }
      ]),
      attrs: {
        "data-key": _vm.user.id + '_' + event.obj.id,
        "content": _vm.i18n['from_another_school'],
        "aria-label": _vm.allOnLessonHumanized(event)
      }
    }, [_c('div', {
      staticClass: "day-cal__event__content",
      on: {
        "click": function($event) {
          return _vm.setPopover(event, $event)
        }
      }
    }, [_c('div', {
      staticClass: "day-cal__event__subs"
    }, [(event.othersOnLessonForBadge.length > 0) ? _c('div', {
      staticClass: "day-cal__event__other"
    }, [_vm._v("\n          +"), _c('span', {
      staticClass: "icon-user"
    })]) : _vm._e(), _vm._v(" "), _vm._l((event.subs), function(sub) {
      return _c('img', {
        staticClass: "day-cal__event__subs__img",
        attrs: {
          "src": sub && sub.default_thumb_url ? sub.default_thumb_url : '',
          "alt": sub && sub.name ? sub.name : ''
        }
      })
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__content__title"
    }, [_c('span', {
      staticClass: "nowrap day-cal__event__content__title__title"
    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.klassesOnLesson.length > 0) ? _c('span', {
      staticClass: "nowrap day-cal__event__content__title__grade"
    }, [_vm._v(_vm._s(event.klassesAsString))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__bg",
      style: ({
        backgroundColor: event.obj.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__sider",
      style: ({
        backgroundColor: event.obj.color
      })
    })])])
  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
    return (_vm.userAbsence.length < 1) ? _c('div', {
      key: presence.obj.id,
      staticClass: "day-cal__event work_hours",
      style: ([{
          'left': presence.left + 'px'
        },
        {
          'right': presence.right + 'px'
        }
      ])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.userAbsenceForPlacing), function(absence) {
    return _c('div', {
      key: absence.obj.id,
      staticClass: "user_absence pointer",
      class: {
        'user_absence--stacked': absence.stackTop > 0
      },
      style: ([{
          'left': absence.left + 'px'
        },
        {
          'right': absence.right + 'px'
        },
        {
          'top': absence.stackTop + 'px'
        },
        {
          'height': absence.stackHeight
        }
      ]),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setPopover(absence)
        }
      }
    }, [_c('div', {
      staticClass: "user_absence__text",
      domProps: {
        "innerHTML": _vm._s(_vm.getAbsenceTitle(absence.obj))
      }
    })])
  }), _vm._v(" "), (_vm.isShowSetAsSubButton) ? _c('div', {
    staticClass: "select-user__button",
    class: {
      'select-user__button--loading': _vm.selectButtonLoading
    },
    style: ({
      left: (_vm.styleObj.left + 2) + 'px',
      right: (_vm.styleObj.right + 2) + 'px',
      backgroundColor: _vm.styleObj.color
    }),
    on: {
      "click": _vm.setAddSubstitute
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeEventsFiltered), function(activeEvent) {
    return _c('div', {
      staticClass: "select-user__button",
      class: {
        'select-user__button--loading': _vm.isActiveEventsLoading
      },
      style: ({
        left: (activeEvent.left + 2) + 'px',
        right: (activeEvent.right + 2) + 'px',
        backgroundColor: activeEvent.color
      }),
      on: {
        "click": _vm.addSubToActiveEvents
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71f48356!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/SchedulerItem.vue
// module id = 2006
// module chunks = 1